/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a room match group
 * @export
 * @interface CreateRoomMatchGroupRequest
 */
export interface CreateRoomMatchGroupRequest {
    /**
     * ID of the comparison
     * @type {number}
     * @memberof CreateRoomMatchGroupRequest
     */
    comparisonId: number;
    /**
     * IDs of insurer rooms to match
     * @type {Array<number>}
     * @memberof CreateRoomMatchGroupRequest
     */
    insurerRoomIds: Array<number>;
    /**
     * IDs of contractor rooms to match
     * @type {Array<number>}
     * @memberof CreateRoomMatchGroupRequest
     */
    contractorRoomIds: Array<number>;
    /**
     * Confidence score for manual matches (optional)
     * @type {number}
     * @memberof CreateRoomMatchGroupRequest
     */
    confidenceScore?: number;
    /**
     * User notes about this match
     * @type {string}
     * @memberof CreateRoomMatchGroupRequest
     */
    note?: string;
}

/**
 * Check if a given object implements the CreateRoomMatchGroupRequest interface.
 */
export function instanceOfCreateRoomMatchGroupRequest(value: object): value is CreateRoomMatchGroupRequest {
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('insurerRoomIds' in value) || value['insurerRoomIds'] === undefined) return false;
    if (!('contractorRoomIds' in value) || value['contractorRoomIds'] === undefined) return false;
    return true;
}

export function CreateRoomMatchGroupRequestFromJSON(json: any): CreateRoomMatchGroupRequest {
    return CreateRoomMatchGroupRequestFromJSONTyped(json, false);
}

export function CreateRoomMatchGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRoomMatchGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonId': json['comparisonId'],
        'insurerRoomIds': json['insurerRoomIds'],
        'contractorRoomIds': json['contractorRoomIds'],
        'confidenceScore': json['confidenceScore'] == null ? undefined : json['confidenceScore'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function CreateRoomMatchGroupRequestToJSON(json: any): CreateRoomMatchGroupRequest {
    return CreateRoomMatchGroupRequestToJSONTyped(json, false);
}

export function CreateRoomMatchGroupRequestToJSONTyped(value?: CreateRoomMatchGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'insurerRoomIds': value['insurerRoomIds'],
        'contractorRoomIds': value['contractorRoomIds'],
        'confidenceScore': value['confidenceScore'],
        'note': value['note'],
    };
}

